import { useEffect, useState } from 'react';
import APIExtensions from '../../../../yoello-lib/modules/API2/APIDefs';
import { useAPIV2 } from "../../../../yoello-lib/modules/API2/useAPIv2";
import { useSelector } from 'react-redux';
import { IReduxAppState } from '../../../../reducers';
import useCheckPermissions from '../../../../hooks/useCheckPermissions';
import { PERMISSIONS } from '../../../../const/permissions.const';
import { useIsSuperuser } from '../../../../hooks/useIsSuperuser';
import { Permission } from '../PermissionChecklist/usePermissionChecklist';
import { HTTPMethods } from '../../../../yoello-lib/modules/API/API';


const useCanUserEditMerchant = (merchantId: string) => {

    const { isSuperuser }  = useIsSuperuser();

    const [ hasPermission, setHasPermission ] = useState(false);
    const [ rowPermissions, setRowPermissions ] = useState<Permission[]>([]);
    const [ rowHasAdminPermission, setRowHasAdminPermission ] = useState(false);

    const venueID = useSelector((state: IReduxAppState) => state.selectedVenueId);

    const { hasPermission: hasUserManagementPermission, onFailedInteraction: onFailedUser } = useCheckPermissions(PERMISSIONS.USER_MANAGEMENT);
    const { hasPermission: hasAdminPermission, onFailedInteraction: onFailedAdmin } = useCheckPermissions(PERMISSIONS.ADMIN);

    const {callAPI, isLoading }  = useAPIV2(APIExtensions.venueMerchant, {
        onMountDisabled: true,
    });

    useEffect( () => {
        if(merchantId){
            callAPI(HTTPMethods.GET,{
                query: `${venueID}/merchants/${merchantId}/permissions`,
            }).then(({data, isSuccessful})=>{
                if(isSuccessful && data){
                    setRowPermissions(data as Permission[])
                }
            })
        }
        // eslint-disable-next-line
    }, [merchantId])

    useEffect(() => {
        if(rowPermissions.length > 0) {
            const rowAdminPermissions = rowPermissions.find((item: Permission) => item.permission_set === PERMISSIONS.ADMIN);
            setRowHasAdminPermission(rowAdminPermissions?.value!);
        }
    }, [rowPermissions])
  
    useEffect(() => {

        if(rowPermissions && !isLoading) {
            setHasPermission(
                (hasUserManagementPermission || isSuperuser) &&
                (!rowHasAdminPermission || hasAdminPermission )
            )
        }
        //eslint-disable-next-line
    }, [hasUserManagementPermission, hasAdminPermission, rowPermissions, isLoading])

    return {
        hasPermission,
        isLoading:merchantId ? isLoading : false,
        onFailedInteraction: !hasUserManagementPermission ? onFailedUser : onFailedAdmin
    }
}

export default useCanUserEditMerchant;